/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rapporten_Config_Elements_Motorische_ResultatenInputs */

const nl_rapporten_config_elements_motorische_resultaten = /** @type {(inputs: Rapporten_Config_Elements_Motorische_ResultatenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Motorische resultaten`)
};

/**

* @param {Rapporten_Config_Elements_Motorische_ResultatenInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const rapporten_config_elements_motorische_resultaten = /** @type {((inputs?: Rapporten_Config_Elements_Motorische_ResultatenInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rapporten_Config_Elements_Motorische_ResultatenInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_rapporten_config_elements_motorische_resultaten(inputs)
});
export { rapporten_config_elements_motorische_resultaten as "rapporten.config.elements.motorische_resultaten" }